module.exports = __webpack_public_path__ + "static/img/bird4.ef26ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird4.png
// module id = mWRi
// module chunks = 1